<template v-if="user.cards.length > 0">
  <div class="current_cards">
    <h3 class="component_heading">{{ $t("loyalty.heading") }}</h3>
    {{ hideAllRules() }}
    <div v-for="(card, cardIndex) in user.cards" :key="cardIndex">


      <!-- M-Friends (card.club=4) не показуємо -->
      <div class="cards" v-if="card.club !== 4">
      <!-- <div class="cards"> -->
        <div class="card">
          <div class="info">
            <div class="left">
              <div class="poster-holder">
                <qrcode-vue :value="card.number" :size="180" level="H"></qrcode-vue>
              </div>
            </div>
            <div class="right">
              <h3 class="card_heading">{{ $t("loyalty.card_name") }} {{ card.club === 1 ? $t("loyalty.card_type_employee") : '' }}</h3>
              <div class="ticket-body">
                <div class="kvs">
                  <div class="kv">
                    <p class="key">{{ card.club === 1 ? $t("loyalty.remained_tickets") : $t("loyalty.remained_points")}}</p>
                    <!-- <p class="val">{{ user.balance.points }}</p> -->
                    <!-- <p class="val">SOON</p> -->
                    <p class="val">{{ getFreeTickets(card.name, recognitions) }}</p>
                  </div>
                  <div class="kv">
                    <p class="key">{{ $t("loyalty.number_card") }}</p>
                    <p class="val">{{ card.number }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rules" 
            @click="onShowRules(cardIndex)"
            :class="{'open': card.isShowRules }"
          >
            <div class="head">
              <div class="title">
                <span>Правила:</span>
                <!-- <span class="card-name">{{ card.name }}</span> -->
              </div>
              <div class="det_pic"></div>
            </div>
            <div class="vis">
              <div class="descr">
                <ho-rules         v-if=" card.name === 'HO' "></ho-rules>
                <line-rules       v-if=" card.name === 'line' "></line-rules>
                <m-friends-rules  v-if=" card.name === 'MFriends' "></m-friends-rules>
              </div>            

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import QrcodeVue from 'qrcode.vue'
  import HORules from './rules/ho-rules.vue'
  import LineRules from './rules/line-rules.vue'
  import MFriendsRules from './rules/m-friends-rules.vue'
  import Store from '../../store'
  export default {
    computed: {
      winW: function () {
        return Store.state.winW
      },
      user: function () {
        return Store.state.user
      },
      showRules: function () {
        return Store.state.showRules
      },
      recognitions: function () {
        return Store.state.user.recognitions
      }
    },
    methods: {
      setTicketsForShare: function (tickets) {
        Store.commit('setTicketsForShare', tickets)
      },
      setTktQr: function (order, movie) {
        Store.commit('setTktQrOrder', order)
        Store.commit('setTktQrMovie', movie)
      },
      getQRCodeImg: function (card) {
        let result = '/static/img/mob_poster_placeholder.jpg'
        if (card.QRCodeImg) {
          result = card.QRCodeImg
        }
        return result
      },
      onShowRules: function (cardIndex) {
        Store.commit('setShowRules', {cardIndex})
      },
      hideAllRules: function () {
        Store.commit('hideAllRules')
      },
      getFreeTickets: function (cardName, recognitions) {
        let rec = recognitions.find(recog => recog.name === cardName)
        if (rec) {
          return rec.available
        } else {
          return 'SOON'
        }
      }
    },
    components: {
      QrcodeVue,
      'ho-rules': HORules,
      'line-rules': LineRules,
      'm-friends-rules': MFriendsRules
    }
  }
</script>



// WEBPACK FOOTER //
// loyalty.vue?676919d9